
<template>
  <div class="ping">

             <h3 class="font-semibold text-2xl text-purple-700  mt-4 pb-4 w-full text-center">Ping Service</h3>

<div v-if="!allowPing" class="w-1/3 mx-auto">
           <ul class="mb-4 " >
                  <li class="inline-block"> 
                    <h3>Enter access code</h3>
                      <input type="number" v-model="code" class="bg-gray-200 p-5 rounded" maxlength="6" />
                  </li>
                            </ul>

                              <button @click="checkPasscode()" 
                  class="text-white bg-purple-700 rounded p-2 w-8/12 mb-4 cursor-pointer inline-flex items-center justify-center">
                  Check Code</button>

                </div>

                <div v-if="allowPing" >
                   <div style="width:100%; text-align:center;" v-if="loading" >
                    <i class="spinner fa fa-spinner fa-spin"></i>
                  </div>

                 
                  <div v-if="success" class="text-green-400">
                    Connection success
                  </div>

                  <div v-if="errored" class="text-red-400">
                    Connection fail {{msg}}
                  </div>


                </div>

                 <p v-if="failure">No Access</p>
  </div>
</template>

<script>
import { BaseService } from "@/services/school.service";

const PASSCODE = {ACCESS: 786543 }

export default {
  name: 'ping',
  computed: {
  },
  data () {
    return {
      loading: false,
      errored: false,
      success: false,
      allowPing: false,
      code: 0,
      failure: false,
      msg: ''
    }
  },
  created() {

  },
  mounted () {
  },
  methods: {
    checkPasscode() {
      if (this.code == PASSCODE.ACCESS) {
        this.allowPing = true
        this.failure = false
        this.ping()
      } else {
        this.failure = true
      }
    },
    ping() {
      this.loading = true
      BaseService.create("/ping/check", null)
        .then(response => this.success = true)
        .catch(err => {
          console.log("ERRROR " + err);
          this.msg = "ERRROR " + err
          this.errored = true;
          this.loading = false
        })
        .finally(() => (this.loading = false));
    },
  },
  components: {

  }
}
</script>

<style scoped>
</style>
